import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=6eeb19ae&"
import script from "./GlobalLoader.vue?vue&type=script&lang=js&"
export * from "./GlobalLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eeb19ae')) {
      api.createRecord('6eeb19ae', component.options)
    } else {
      api.reload('6eeb19ae', component.options)
    }
    module.hot.accept("./GlobalLoader.vue?vue&type=template&id=6eeb19ae&", function () {
      api.rerender('6eeb19ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/layout/GlobalLoader.vue"
export default component.exports